import { combineReducers } from 'redux';
import Languages from './languages';
export default combineReducers({Languages,});